import React, { useRef } from "react";
import { useEditor, EditorContent } from "@tiptap/react";

import StarterKit from "@tiptap/starter-kit";
import Underline from "@tiptap/extension-underline";
import TextAlign from "@tiptap/extension-text-align";
import Placeholder from "@tiptap/extension-placeholder";

import {
  Bold,
  Italic,
  Underline as UnderlineIcon,
  List,
  ListOrdered,
  Heading1,
  Heading2,
  Heading3,
  Undo,
  Redo,
} from "lucide-react";


// 🔥 Toolbar (LIKE YOUR UI)
function Toolbar({ editor }) {
  const btn = (onClick, icon, active) => (
    <button
      onClick={onClick}
      className={`p-1 rounded hover:bg-gray-200 ${active ? "bg-gray-300" : ""
        }`}
    >
      {icon}
    </button>
  );

  return (
    <div className="flex items-center gap-2 px-3 py-2 border-b bg-gray-50 rounded-t-lg">

      {btn(() => editor.chain().focus().undo().run(), <Undo size={16} />)}
      {btn(() => editor.chain().focus().redo().run(), <Redo size={16} />)}

      <div className="w-px h-5 bg-gray-300 mx-1" />

      {btn(() => editor.chain().focus().toggleHeading({ level: 1 }).run(), <Heading1 size={16} />)}
      {btn(() => editor.chain().focus().toggleHeading({ level: 2 }).run(), <Heading2 size={16} />)}
      {btn(() => editor.chain().focus().toggleHeading({ level: 3 }).run(), <Heading3 size={16} />)}

      <div className="w-px h-5 bg-gray-300 mx-1" />

      {btn(() => editor.chain().focus().toggleBold().run(), <Bold size={16} />, editor.isActive("bold"))}
      {btn(() => editor.chain().focus().toggleItalic().run(), <Italic size={16} />, editor.isActive("italic"))}
      {btn(() => editor.chain().focus().toggleUnderline().run(), <UnderlineIcon size={16} />, editor.isActive("underline"))}

      <div className="w-px h-5 bg-gray-300 mx-1" />

      {btn(() => editor.chain().focus().toggleBulletList().run(), <List size={16} />)}
      {btn(() => editor.chain().focus().toggleOrderedList().run(), <ListOrdered size={16} />)}

    </div>
  );
}


// 🔥 MAIN EDITOR
function TiptapEditor({ content, onChange }) {
  const editor = useEditor({
    extensions: [
      StarterKit,
      Underline,
      TextAlign.configure({ types: ["heading", "paragraph"] }),
      Placeholder.configure({
        placeholder: "Start writing your template...",
      }),
    ],
    content: content || "<p></p>",
    onUpdate: ({ editor }) => {
      onChange(editor.getHTML());
    },
  });

  if (!editor) return null;

  return (
    <div className="w-full mx-auto mt-6">
      {/* Editor Box */}
      <div className="bg-white rounded-xl shadow border overflow-hidden">
        <Toolbar editor={editor} />
        <div className="px-4 py-3 min-h-[200px]">
          <EditorContent editor={editor} />
        </div>

      </div>

    </div>
  );
}

export default TiptapEditor;